import { useCallback, useState } from 'react';

interface IUseSimpleModalDeps {
  initialState?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export type TUseSimpleModalResult = [boolean, () => void, () => void];

/**
 * Простой хук для управления состоянием "Открыто/Закрыто" у модалок.
 * Возвращает только состояние isOpen и хендлеры для управления им.
 */
export function useSimpleModal(deps?: IUseSimpleModalDeps): TUseSimpleModalResult {
  const { initialState = false, onOpen, onClose } = deps || {};
  const [isOpen, setIsOpen] = useState(initialState);

  const openHandler = useCallback(() => {
    setIsOpen(true);
    onOpen?.();
  }, [onOpen]);

  const closeHandler = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);

  return [isOpen, openHandler, closeHandler];
}
